import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import birdFood from './../../../images/bird-food.png';
import powercss from './../../../styles/power.css';
import template from './accessibility.html';

@Component({
  controllerAs: 'accessibility',
  template
})

export default class Accessibility {
  static $inject = [
    '$rootScope',
    '$scope',
    '$ngRedux',
    '$stateParams',
    '$state',
    'toaster',
    'orderService',
    'spinnerService',
    'orderActions',
    'authService',
    '$window',
    'APP',
    'ngMeta'
  ];

  constructor($rootScope,$scope, $ngRedux, $stateParams, $state, $toaster, $order, $spinner, orderActions, $auth, $window, APP, ngMeta) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.birdFood = birdFood;
    this.$state = $state;
    this.$toaster = $toaster;
    this.$auth = $auth;
    this.$window = $window;
    this.APP = APP;
    this.ngMeta = ngMeta;
    this.$spinner = $spinner;
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.subCategoryName ='';
    this.categoryName = '';
    this.storeName = '';
  }

  mapState(state) {
    return {
        profile: state.auth.profile
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/order/accessibility/accessibility.js